import IndividualTypeList from "./IndividualTypeList";

const Initiatives = () => {
  return <IndividualTypeList type={"initiatives"} />;
};

export default Initiatives;
